<template>
  <!-- End print marker -->
  <div style="display: none;">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'EndPrint'
}
</script>

<style scoped>
/* No additional styles needed */
</style>